/**
 * 高级筛选组件国际化配置 - 中文
 */
export default {
  // FCL整箱运价筛选字段
  fcl: {
    labels: {
      routeCode: '运价号',
      rateType: '运价类型',
      departurePort: '起运港',
      dischargePort: '目的港',
      directTransit: '直达/中转',
      transitPort: '中转港',
      transitType: '中转类型',
      shipCompany: '船公司',
      contractNo: '约号',
      spaceStatus: '舱位状态',
      priceStatus: '价格趋势',
      cargoType: '货物类型',
      vesselSchedule: '船期',
      voyage: '航程',
      freeStorageDays: '免用箱',
      nac: 'NAC',
      validPeriod: '有效期',
      etd: 'ETD',
      eta: 'ETA',
      vesselName: '船名',
      voyageNo: '航次',
      cutoffDate: '截关日',
      destinationRegion: '目的区域',
      entryPerson: '创建人',
      createDate: '创建日期',
      rateModifier: '运价修改人',
      modifyDate: '修改日期',
      rateStatus: '运价状态',
      routeName: '航线名称',
      routeCodeSelect: '航线代码',
      terminal: '码头',
      branch: '分公司'
    },
    placeholders: {
      routeCode: '请输入运价号',
      rateType: '请选择运价类型',
      departurePort: '请选择起运港',
      dischargePort: '请选择目的港',
      directTransit: '请选择直达/中转',
      transitPort: '请选择中转港',
      transitType: '请选择中转类型',
      shipCompany: '请选择船公司',
      contractNo: '请选择约号',
      spaceStatus: '请选择舱位状态',
      priceStatus: '请选择价格趋势',
      cargoType: '请选择货物类型',
      vesselSchedule: '请选择船期',
      voyage: '请输入航程',
      freeStorageDays: '请输入免柜租期',
      nac: '请选择NAC',
      validPeriod: '请选择有效期范围',
      etd: '请选择ETD范围',
      eta: '请选择ETA范围',
      vesselName: '请输入船名',
      voyageNo: '请输入航次',
      cutoffDate: '请选择截关日范围',
      destinationRegion: '请输入目的区域',
      entryPerson: '请输入创建人',
      createDate: '请选择创建日期范围',
      rateModifier: '请输入运价修改人',
      modifyDate: '请选择修改日期范围',
      rateStatus: '请选择运价状态',
      routeName: '请选择航线名称',
      routeCodeSelect: '请选择航线代码',
      terminal: '请选择码头',
      branch: '请选择分公司'
    }
  },

  // LCL拼箱运价筛选字段
  lcl: {
    labels: {
      rateCode: '运价号',
      rateType: '运价类型',
      departurePort: '起运港',
      dischargePort: '目的港',
      transitType: '直达/中转',
      shipCompany: '船公司',
      weightRange: '重量范围',
      volumeRange: '体积范围',
      validPeriod: '有效期',
      etd: 'ETD',
      eta: 'ETA',
      cutoffDate: '截关日',
      createDate: '创建日期',
      modifyDate: '修改日期'
    },
    placeholders: {
      rateCode: '请输入运价号',
      rateType: '请选择运价类型',
      departurePort: '请选择起运港',
      dischargePort: '请选择目的港',
      transitType: '请选择直达/中转',
      shipCompany: '请选择船公司',
      weightRange: '请输入重量范围',
      volumeRange: '请输入体积范围',
      validPeriod: '请选择有效期范围',
      etd: '请选择ETD范围',
      eta: '请选择ETA范围',
      cutoffDate: '请选择截关日范围',
      createDate: '请选择创建日期范围',
      modifyDate: '请选择修改日期范围'
    }
  },

  // 空运运价筛选字段
  air: {
    labels: {
      rateCode: '运价号',
      rateType: '运价类型',
      departureAirport: '起飞机场',
      arrivalAirport: '到达机场',
      airline: '航空公司',
      weightRange: '重量范围',
      validPeriod: '有效期',
      flightDate: '航班日期',
      createDate: '创建日期',
      modifyDate: '修改日期'
    },
    placeholders: {
      rateCode: '请输入运价号',
      rateType: '请选择运价类型',
      departureAirport: '请选择起飞机场',
      arrivalAirport: '请选择到达机场',
      airline: '请选择航空公司',
      weightRange: '请输入重量范围',
      validPeriod: '请选择有效期范围',
      flightDate: '请选择航班日期范围',
      createDate: '请选择创建日期范围',
      modifyDate: '请选择修改日期范围'
    }
  },

  // 港前运价筛选字段
  precarriage: {
    labels: {
      rateCode: '港前运价编号',
      rateType: '运价类型',
      origin: '起运地',
      destination: '起运港',
      terminal: '码头',
      vendor: '供应商',
      validPeriod: '有效期',
      status: '状态',
      entryPerson: '创建人',
      createDate: '创建日期',
      rateModifier: '修改人',
      modifyDate: '修改日期'
    },
    placeholders: {
      rateCode: '请输入港前运价编号',
      rateType: '请选择运价类型',
      origin: '请输入起运地',
      destination: '请选择起运港',
      terminal: '请选择码头',
      vendor: '请输入供应商',
      validPeriod: '请选择有效期范围',
      status: '请选择状态',
      entryPerson: '请输入创建人',
      createDate: '请选择创建日期范围',
      rateModifier: '请输入修改人',
      modifyDate: '请选择修改日期范围'
    }
  },

  // 尾程运价筛选字段
  oncarriage: {
    labels: {
      rateCode: '尾程运价编号',
      origin: '目的港',
      addressType: '配送地址类型',
      zipCode: '邮编',
      address: '地址',
      agentName: '代理名称',
      validPeriod: '有效期',
      status: '状态'
    },
    placeholders: {
      rateCode: '请输入尾程运价编号',
      origin: '请输入目的港',
      addressType: '请选择配送地址类型',
      zipCode: '请输入邮编',
      address: '请输入地址',
      agentName: '请输入代理名称',
      validPeriod: '请选择有效期范围',
      status: '请选择状态'
    }
  },

  // 询价筛选字段
  inquiry: {
    labels: {
      inquiryNo: '询价编号',
      source: '询价来源',
      inquirerId: '询价人',
      status: '询价状态',
      carrierId: '船公司',
      trunkLineEnable: '干线报价状态',
      prePortEnable: '头程报价状态',
      lastMileEnable: '尾程报价状态',
      cargoReadyTimeType: '货好时间类型',
      cargoReadyTimeRange: '货好时间区间',
      cargoReadyTimeDate: '货好时间',
      palletNature: '货盘性质',
      directTransit: '直达/中转',
      routeId: '航线',
      loadingPortId: '起运港',
      dischargingPortId: '卸货港',
      destinationPortId: '目的港',
      cargoType: '货物类型',
      serviceTerm: '服务条款',
      customServiceTerm: '自定义服务条款',
      clientType: '委托单位类型',
      clientTitle: '委托单位名称',
      seaEq: '箱型箱量',
      remarks: '备注',
      dateCreated: '创建时间',
      dateModified: '修改时间',
      createdBy: '创建人',
      modifiedBy: '修改人'
    },
    placeholders: {
      inquiryNo: '请输入询价编号',
      source: '请选择询价来源',
      inquirerId: '请选择询价人',
      status: '请选择询价状态',
      carrierId: '请选择船公司',
      trunkLineEnable: '请选择干线报价状态',
      prePortEnable: '请选择头程报价状态',
      lastMileEnable: '请选择尾程报价状态',
      cargoReadyTimeType: '请选择货好时间类型',
      cargoReadyTimeRange: '请选择货好时间区间',
      cargoReadyTimeDate: '请选择货好时间范围',
      palletNature: '请选择货盘性质',
      directTransit: '请选择直达/中转',
      routeId: '请选择航线',
      loadingPortId: '请选择起运港',
      dischargingPortId: '请选择卸货港',
      destinationPortId: '请选择目的港',
      cargoType: '请选择货物类型',
      serviceTerm: '请选择服务条款',
      customServiceTerm: '请输入自定义服务条款',
      clientType: '请选择委托单位类型',
      clientTitle: '请输入委托单位名称',
      seaEq: '请输入箱型箱量',
      remarks: '请输入备注',
      dateCreated: '请选择创建时间范围',
      dateModified: '请选择修改时间范围',
      createdBy: '请选择创建人',
      modifiedBy: '请选择修改人'
    }
  },

  // 报价筛选字段
  quotation: {
    labels: {
      quotationNo: '报价编号',
      inquiryNo: '询价编号',
      quoterId: '报价人',
      source: '报价来源',
      status: '报价状态',
      carrierId: '船公司',
      trunkLineEnable: '干线报价状态',
      prePortEnable: '头程报价状态',
      lastMileEnable: '尾程报价状态',
      cargoReadyTimeType: '货好时间类型',
      cargoReadyTimeRange: '货好时间区间',
      cargoReadyTimeDate: '货好时间',
      palletNature: '货盘性质',
      directTransit: '直达/中转',
      routeId: '航线',
      loadingPortId: '起运港',
      dischargingPortId: '卸货港',
      destinationPortId: '目的港',
      clientType: '委托单位类型',
      clientTitle: '委托单位名称',
      seaEq: '箱型箱量',
      remarks: '备注',
      dateCreated: '创建时间',
      dateModified: '修改时间',
      createdBy: '创建人',
      modifiedBy: '修改人'
    },
    placeholders: {
      quotationNo: '请输入报价编号',
      inquiryNo: '请输入询价编号',
      quoterId: '请选择报价人',
      source: '请选择报价来源',
      status: '请选择报价状态',
      carrierId: '请选择船公司',
      trunkLineEnable: '请选择干线报价状态',
      prePortEnable: '请选择头程报价状态',
      lastMileEnable: '请选择尾程报价状态',
      cargoReadyTimeType: '请选择货好时间类型',
      cargoReadyTimeRange: '请选择货好时间区间',
      cargoReadyTimeDate: '请选择货好时间范围',
      palletNature: '请选择货盘性质',
      directTransit: '请选择直达/中转',
      routeId: '请选择航线',
      loadingPortId: '请选择起运港',
      dischargingPortId: '请选择卸货港',
      destinationPortId: '请选择目的港',
      clientType: '请选择委托单位类型',
      clientTitle: '请输入委托单位名称',
      seaEq: '请输入箱型箱量',
      remarks: '请输入备注',
      dateCreated: '请选择创建时间范围',
      dateModified: '请选择修改时间范围',
      createdBy: '请选择创建人',
      modifiedBy: '请选择修改人'
    }
  },

  // 枚举值翻译
  enums: {
    // 运价类型
    rateType: {
      contract: '合约价',
      spot: 'SPOT电商',
      peer: '同行价格',
      ratio: '配比价格'
    },
    // 路由类型
    routeType: {
      direct: '直达',
      transit: '中转'
    },
    // 是/否
    yesNo: {
      yes: '是',
      no: '否'
    },

    // 舱位状态
    spaceStatus: {
      smooth: '畅接',
      normal: '正常',
      singleApply: '单票申请',
      overbooked: '爆舱',
      rejected: '不接',
      limited: '紧张',
      suspended: '停航',
      inquiry: '询盘'
    },
    // 舱位性质
    spaceNature: {
      selfOperated: '自营',
      shared: '共舱'
    },
    // 特价状态
    specialPriceStatus: {
      notAllowed: '不允许申请特价',
      allowed: '允许申请特价',
      special: '特价'
    },
    // 航线类型
    laneType: {
      economy: '经济航线',
      express: '快速航线'
    },
    // 箱属
    containerOwnership: {
      coc: 'COC-承运人箱',
      soc: 'SOC-货主箱'
    },
    // 价格趋势
    priceTrend: {
      up: '上涨',
      down: '下跌',
      stable: '平稳'
    },
    // 货物类型
    cargoType: {
      general: '普货',
      dangerous: '危险品',
      frozen: '冷冻品',
      special: '特殊货物',
      steelCoil: '钢卷',
      liquid: '液体',
      chemical: '化工品',
      textile: '纺织品',
      liveAnimals: '活体物品'
    },
    // 船期（周几）
    weekDay: {
      monday: '周一',
      tuesday: '周二',
      wednesday: '周三',
      thursday: '周四',
      friday: '周五',
      saturday: '周六',
      sunday: '周日'
    },

    // 运价状态
    rateStatus: {
      draft: '待上架',
      published: '已发布',
      invalid: '已失效',
      offline: '已下架',
      disabled: '已禁用',
      pendingImport: '待导入'
    },

    // 询价类型
    inquiryType: {
      fcl: '整箱询价',
      lcl: '拼箱询价',
      air: '空运询价',
      prePort: '港前询价',
      lastMile: '尾程询价'
    },

    // 询价状态
    inquiryStatus: {
      draft: '草稿',
      submitted: '已提交',
      sent: '已发送',
      quoted: '已报价',
      confirmed: '已确认',
      consulting: '磋商中',
      inStock: '已入库',
      closed: '已关闭'
    },

    // 报价类型
    quotationType: {
      fcl: '整箱报价',
      lcl: '拼箱报价',
      air: '空运报价',
      prePort: '港前报价',
      lastMile: '尾程报价'
    },

    // 报价状态
    quotationStatus: {
      draft: '草稿',
      submitted: '已提交'
    },

    // 匹配报价状态
    quoteStatus: {
      pending: '待报价',
      quoted: '已报价',
      notEnabled: '无须报价',
      rejected: '拒绝报价'
    },

    // 货盘性质
    palletNature: {
      inquiry: '询价',
      booking: '实单'
    },

    // 韶音询价性质
    shokzInquiryNature: {
      priceCheck: '核价',
      formalInquiry: '正式询价'
    },

    // 询价来源
    inquirySource: {
      internal: '内部',
      client: '客户',
      agentWecom: '企微Agent',
      cargowareXAgent: 'CargowareX Agent',
      emailAgent: 'Email Agent',
      familyAgent: 'Family Agent'
    },

    // 报价来源
    quotationSource: {
      internal: '内部询价',
      external: '外部询价',
      direct: '直接创建',
      thirdPartySystemPush: '第三方系统推送'
    },

    // 委托单位类型
    clientType: {
      none: '不指定',
      formal: '正式客户',
      temporary: '临时客户'
    },

    // 配送地址类型
    deliveryAddressType: {
      thirdParty: '第三方地址',
      amazon: '亚马逊仓库',
      ecang: '易仓'
    },

    // 直达/中转
    directTransit: {
      direct: '直达',
      transit: '中转',
      none: '不指定'
    },

    // 货好时间类型
    cargoReadyTimeType: {
      range: '区间',
      date: '日期'
    },
    // 用箱要求
    containerRequirement: {
      generalDry: '普通干货箱',
      reefer: '冷藏箱',
      openTop: '开顶箱'
    },

    // 货好时间区间
    cargoReadyTimeRange: {
      threeDays: '三天内',
      oneWeek: '一周内',
      twoWeeks: '二周内',
      oneMonth: '一个月内',
      moreThanMonth: '一个月以上',
      unknown: '时间未知'
    },
    surchargeFeeStatus: {
      disabled: '禁用',
      enabled: '启用',
      expired: '过期'
    },
    surchargeType: {
      oceanFcl: '海运整箱',
      prePort: '港前运价',
      lastMile: '尾程运价',
      oceanLcl: '海运拼箱',
      air: '空运运价'
    },
    surchargeFeeType: {
      oceanFreight: '海运附加费',
      pol: '起运港费用',
      pod: '卸货港费用'
    },
    paymentType: {
      prepaid: '预付',
      collect: '到付',
      prepaidOrCollect: '预付/到付'
    },
    // 服务条款
    serviceTerm: {
      fob: 'FOB',
      cif: 'CIF',
      cfr: 'CFR',
      ddp: 'DDP',
      custom: '自定义'
    },

    // 运价类型
    priceType: {
      fcl: '整箱',
      prePortLastMile: '港前&尾程'
    },

    // 港前尾程运价类型
    pricePrePortLastMileType: {
      prePort: '港前运价',
      lastMile: '尾程运价'
    },

    // 费用条目类型
    chargingItemType: {
      container: '按箱型计费',
      nonContainer: '非按箱型计费'
    },

    // 归属联盟
    belongingAlliance: {
      twoMAlliance: '2M联盟',
      oceanAlliance: '海洋联盟',
      theAlliance: 'THE联盟',
      independentOperation: '独立运营'
    },
    status: {
      enable: '启用',
      disable: '禁用'
    },
    warehouseType: {
      amazon: '亚马逊',
      ecang: '易仓',
      other: '其他',
      factory: '工厂仓',
      fba: 'FBA 仓',
      thirdParty: '3PL 仓',
      selfOwned: '自有仓',
      overseas: '海外仓',
      transit: '中转仓'
    },
    priceMethod: {
      direct: '直拖',
      branch: '支线',
      seaRail: '海铁'
    },
    preportTransportMode: {
      truck: '拖车',
      barge: '驳船',
      rail: '铁路'
    },
    templateUsage: {
      print: '打印',
      email: '邮件'
    },
    businessType: {
      sea: '海运',
      air: '空运',
      rail: '铁路',
      land: '陆运'
    },
    freightType: {
      fcl: '整箱',
      prePort: '港前',
      lastMile: '尾程',
      lcl: '拼箱',
      air: '空运',
      rail: '铁路',
      land: '陆运'
    },
    dedicatedType: {
      sales: '销售',
      service: '客服',
      document: '单证',
      business: '商务',
      operation: '操作',
      shipping: '航线',
      accounting: '财务'
    },
    enterpriseType: {
      customer: '客户企业',
      tenant: '租户企业'
    },
    syncPlatform: {
      cargoware: 'CargoWare',
      etower: 'eTower'
    },
    syncMode: {
      auto: '自动',
      manual: '手动'
    },
    orderSyncStatus: {
      notSynced: '未同步',
      syncing: '同步中',
      synced: '已同步',
      syncFailed: '同步失败',
      preReviewRejected: '预审驳回'
    },
    hazardClass: {
      class1: '1.1 具有整体爆炸危险的爆炸品',
      class2: '1.2 具有严重抛射危险的爆炸品',
      class3: '1.3 具有燃烧危险的爆炸品',
      class4: '1.4 轻微火灾或抛射危险',
      class5: '1.5 具有整体爆炸危险的钝感物质',
      class6: '1.6 极不敏感的物品',
      class7: '2.1 易燃气体',
      class8: '2.2 不燃、无毒气体',
      class9: '2.3 氧气',
      class10: '2.4 毒性气体',
      class11: '3 易燃液体',
      class12: '4.1 易燃固体或物质',
      class13: '4.2 易燃固体',
      class14: '4.3 遇水放出易燃气体的物质',
      class15: '5.1 氧化性物质（通过释放氧气增加火灾风险和强度）',
      class16: '5.2 有机过氧化物 - 大多数燃烧迅速，对撞击或摩擦敏感',
      class17: '6.1 毒性物质',
      class18: '6.2 感染性物质',
      class19: '7 放射性物质',
      class20: '8 腐蚀品',
      class21: '9 杂项危险物质和物品'
    },
    // 数据权限范围类型
    dataScopeType: {
      all: '所有数据',
      branch: '分公司数据',
      department: '部门数据',
      personal: '个人数据'
    },
    // 整拼类型
    containerLoadType: {
      fclExport: '整箱出口',
      lclExport: '拼箱出口',
      iclExport: '拼箱出口',
      airExport: '空运出口',
      railExport: '铁路出口',
      prePort: '港前',
      lastMile: '尾程',
      rail: '铁路',
      express: '快递'
    },
    // 订单来源类型
    orderSourceType: {
      QUOTATION: '商务报价单',
      SUPPLIER_QUOTATION: '供应商报价单',
      SALES_QUOTATION: '报价记录',
      PRICE_FCL: '整箱运价',
      BOOKING_TASK: '订舱任务',
      BOOKING: '创建订舱',
      API_SYNC_CARGOWARE: 'API同步(CargoWare)',
      DIRECT_CREATE: '直接创建'
    }
  },

  // 订单筛选字段
  order: {
    labels: {
      cargoJobNo: 'Cargo业务编号',
      mblNo: 'MBL单号',
      hblNo: 'HBL单号',
      containerNo: '箱号',
      vesselVoyage: '船名航次',
      orderStatus: '订单状态',
      syncStatus: '订单同步状态',
      etd: '预计离港 (ETD)',
      eta: '预计到港 (ETA)',
      airline: '航空公司',
      flightNo: '航班号',
      mawbNo: '主运单号 (MAWB)',
      airEtd: '预计起飞 (ETD)',
      airEta: '预计到达 (ETA)',
      placeOfReceipt: '发货地',
      placeOfDelivery: '交货地',
      pickupPlace: '提柜地',
      returnPlace: '还柜地',
      railOrigin: '发站/起运地',
      railDestination: '到站/目的地',
      railCarrier: '铁路承运人',
      trainNo: '车次号',
      truckPlate: '车牌号'
    },
    placeholders: {
      cargoJobNo: '请输入Cargo业务编号',
      mblNo: '请输入MBL单号',
      hblNo: '请输入HBL单号',
      containerNo: '请输入箱号',
      vesselVoyage: '请输入船名航次',
      orderStatus: '请选择订单状态',
      syncStatus: '请选择订单同步状态',
      airline: '请选择航空公司',
      flightNo: '请输入航班号',
      mawbNo: '请输入主运单号',
      placeOfReceipt: '请输入发货地',
      placeOfDelivery: '请输入交货地',
      pickupPlace: '请输入提柜地',
      returnPlace: '请输入还柜地',
      railOrigin: '请输入发站或起运地',
      railDestination: '请输入到站或目的地',
      trainNo: '请输入车次号',
      truckPlate: '请输入车牌号'
    }
  },

  // 通用筛选操作
  common: {
    operators: {
      EQ: '等于',
      NE: '不等于',
      LIKE: '包含',
      NOT_LIKE: '不包含',
      GT: '大于',
      GTE: '大于等于',
      LT: '小于',
      LTE: '小于等于',
      BETWEEN: '介于',
      IN: '包含于',
      NOT_IN: '不包含于',
      IS_NULL: '为空',
      IS_NOT_NULL: '不为空'
    },
    actions: {
      search: '查询',
      reset: '重置',
      expand: '展开',
      collapse: '收起',
      addCondition: '增减条件',
      saveScheme: '另存为方案',
      selectAll: '全选',
      clearAll: '清空',
      resetDefault: '重置默认'
    },
    messages: {
      noCondition: '暂无筛选条件',
      conditionCount: '已选择 {count} 个字段',
      schemeNameRequired: '请输入方案名称',
      schemeSaveSuccess: '筛选方案保存成功',
      schemeDeleteSuccess: '筛选方案删除成功'
    }
  }
}
